// Port of api/fuel/app/classes/filter/search/games/filters/query/play/locations.php
export default {
	name: 'play.locations',
	priority: 63,
	require: function(config, filter) { return filter.play && filter.play.locations && filter.play.locations.length > 0 },
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.play.locations.length; i++) {
			var loc = filter.play.locations[i]
			if (typeof loc === 'string' && loc.charAt(0) === '-') exclude.push(loc.substring(1))
			else include.push(typeof loc === 'string' ? loc : String(loc))
		}
		if (include.length) query.where('p.play_location', 'text in', include)
		if (exclude.length) query.where('p.play_location', 'text not in', exclude)
	}
}
